import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { withRouter } from 'react-router-dom';
import { withStyles, Card, CardContent, Typography, IconButton, CircularProgress, Tooltip } from '@material-ui/core';
import { Star as StarIcon, StarBorder as StarBorderIcon, LinkOff as LinkOffIcon } from '@material-ui/icons';
import { Toastr } from 'data/common';

class UserCard extends PureComponent {
    static propTypes = {
        theme: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
        isMaster: PropTypes.bool.isRequired,
        dissociateUserFunc: PropTypes.func.isRequired,
        dissociateUserAndSwitchMasterFunc: PropTypes.func.isRequired,
        switchMasterFunc: PropTypes.func.isRequired,
        product: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
        environment: PropTypes.string.isRequired,
        productName: PropTypes.string.isRequired,
        actionDisabled: PropTypes.bool.isRequired,
        disableActions: PropTypes.func.isRequired,
        enableActions: PropTypes.func.isRequired,
        history: PropTypes.object.isRequired,
        otherUsers: PropTypes.array.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            masterLoading: false,
            deleteLoading: false
        };
    }

    render() {
        const {
            theme,
            user,
            isMaster,
            product,
            dissociateUserFunc,
            dissociateUserAndSwitchMasterFunc,
            switchMasterFunc,
            profile,
            environment,
            productName,
            actionDisabled,
            disableActions,
            enableActions,
            otherUsers,
            history,
            classes
        } = this.props;
        const { masterLoading, deleteLoading } = this.state;

        const userRights = profile.getIn(['user_rights', environment], []);
        const removeUserRight = profile.get('admin') || userRights.includes(`${productName}RemoveUser`);
        const switchMasterRight = profile.get('admin') || userRights.includes(`${productName}SwitchMaster`);
        const removeMasterRight = profile.get('admin') || userRights.includes(`${productName}RemoveMaster`);
        const userDetailRight = profile.get('admin') || userRights.includes('userDetails');
        const areOtherUsers = otherUsers.length > 0;

        return (
            <Card
                className={`${classes.userCardContainer} ${isMaster && classes.masterStyle}`}
                onClick={() => {
                    if (userDetailRight) return history.push({ pathname: `/${environment}/user/detail/${user.get('_id')}` });
                }}
            >
                <CardContent>
                    {isMaster ? (
                        <div className={classes.actionIcons}>
                            <IconButton disabled aria-label="ChangeMaster">
                                <StarIcon className={classes.starIcon} />
                            </IconButton>
                            <Tooltip title={Translator.translate('generic.user.actions.confirmRemoveMasterTitle')} placement="top">
                                <span>
                                    <IconButton
                                        disabled={actionDisabled}
                                        hidden={(!removeUserRight && !switchMasterRight && areOtherUsers) || (!removeMasterRight && !areOtherUsers)}
                                        aria-label="Delete"
                                        style={{ color: theme.palette.primary.main }}
                                        onClick={e => {
                                            e.stopPropagation();
                                            disableActions();
                                            this.setState({ deleteLoading: true });
                                            if (!areOtherUsers) {
                                                Toastr.confirm(
                                                    Translator.translate(
                                                        'generic.user.actions.confirmRemoveMasterAlone',
                                                        user.get('firstname'),
                                                        user.get('lastname')
                                                    ),
                                                    Translator.translate('generic.user.actions.confirmRemoveMasterTitle'),
                                                    {
                                                        onYes: () => {
                                                            dissociateUserFunc(product.get('macAddress'), user.get('_id')).catch(() => {
                                                                this.setState({ deleteLoading: false });
                                                            });
                                                        },
                                                        onNo: () => {
                                                            enableActions();
                                                            this.setState({ deleteLoading: false });
                                                        }
                                                    }
                                                );
                                            } else {
                                                Toastr.select(
                                                    Translator.translate(
                                                        'generic.user.actions.confirmRemoveMaster',
                                                        user.get('firstname'),
                                                        user.get('lastname')
                                                    ),
                                                    Translator.translate('generic.user.actions.confirmRemoveMasterTitle'),
                                                    otherUsers,
                                                    {
                                                        onYes: masterId => {
                                                            dissociateUserAndSwitchMasterFunc(
                                                                product.get('macAddress'),
                                                                user.get('_id'),
                                                                parseInt(masterId)
                                                            ).catch(() => {
                                                                this.setState({ deleteLoading: false });
                                                            });
                                                        },
                                                        onNo: () => {
                                                            enableActions();
                                                            this.setState({ deleteLoading: false });
                                                        }
                                                    }
                                                );
                                            }
                                        }}
                                    >
                                        {!deleteLoading ? (
                                            <LinkOffIcon className={classes.linkOffIcon} />
                                        ) : (
                                            <CircularProgress size={25} color="inherit" />
                                        )}
                                    </IconButton>
                                </span>
                            </Tooltip>
                        </div>
                    ) : (
                        <div className={classes.actionIcons}>
                            <Tooltip title={Translator.translate('generic.user.actions.confirmSwitchMasterTitle')} placement="top">
                                <span>
                                    <IconButton
                                        disabled={actionDisabled}
                                        hidden={!switchMasterRight}
                                        aria-label="ChangeMaster"
                                        onClick={e => {
                                            e.stopPropagation();
                                            disableActions();
                                            this.setState({ masterLoading: true });
                                            Toastr.confirm(
                                                Translator.translate(
                                                    'generic.user.actions.confirmSwitchMaster',
                                                    user.get('firstname'),
                                                    user.get('lastname')
                                                ),
                                                Translator.translate('generic.user.actions.confirmSwitchMasterTitle'),
                                                {
                                                    onYes: () => {
                                                        switchMasterFunc(product.get('macAddress'), user.get('_id')).finally(() => {
                                                            this.setState({ masterLoading: false });
                                                        });
                                                    },
                                                    onNo: () => {
                                                        enableActions();
                                                        this.setState({ masterLoading: false });
                                                    }
                                                }
                                            );
                                        }}
                                    >
                                        {!masterLoading ? (
                                            <StarBorderIcon className={classes.starIcon} />
                                        ) : (
                                            <CircularProgress size={25} color="inherit" />
                                        )}
                                    </IconButton>
                                </span>
                            </Tooltip>
                            <Tooltip title={Translator.translate('generic.user.actions.confirmRemoveTitle')} placement="top">
                                <span>
                                    <IconButton
                                        disabled={actionDisabled}
                                        hidden={!removeUserRight}
                                        aria-label="Delete"
                                        onClick={e => {
                                            e.stopPropagation();
                                            disableActions();
                                            this.setState({ deleteLoading: true });
                                            Toastr.confirm(
                                                Translator.translate(
                                                    'generic.user.actions.confirmRemove',
                                                    user.get('firstname'),
                                                    user.get('lastname')
                                                ),
                                                Translator.translate('generic.user.actions.confirmRemoveTitle'),
                                                {
                                                    onYes: () => {
                                                        dissociateUserFunc(product.get('macAddress'), user.get('_id')).catch(() => {
                                                            this.setState({ deleteLoading: false });
                                                        });
                                                    },
                                                    onNo: () => {
                                                        enableActions();
                                                        this.setState({ deleteLoading: false });
                                                    }
                                                }
                                            );
                                        }}
                                    >
                                        {!deleteLoading ? (
                                            <LinkOffIcon className={classes.linkOffIcon} />
                                        ) : (
                                            <CircularProgress size={25} color="inherit" />
                                        )}
                                    </IconButton>
                                </span>
                            </Tooltip>
                        </div>
                    )}
                    <div className={classes.content}>
                        <Typography variant="h5" className={`${classes.nameText} ${classes.primaryColor}`}>
                            {user.get('lastname')} {user.get('firstname')}
                        </Typography>
                        <Typography color="textSecondary" className={classes.emailText}>
                            {user.get('email')}
                        </Typography>
                    </div>
                </CardContent>
            </Card>
        );
    }
}

const styles = theme => ({
    primaryColor: {
        color: theme.palette.primary.main
    },
    userCardContainer: {
        position: 'relative',
        width: '100%',
        margin: '10px 0',
        minHeight: 130,
        cursor: 'pointer'
    },
    masterStyle: {
        border: `solid 1px ${theme.palette.primary.main}`
    },
    actionIcons: {
        display: 'flex',
        position: 'absolute',
        right: 0,
        top: 0
    },
    content: {
        paddingTop: 30
    },
    starIcon: {
        color: theme.palette.primary.main,
        fontSize: 25
    },
    linkOffIcon: {
        fontSize: 25
    },
    nameText: {
        overflowWrap: 'break-word',
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.3em'
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: '1.1em'
        }
    },
    emailText: {
        overflowWrap: 'break-word',
        [theme.breakpoints.down('sm')]: {
            fontSize: '0.9em'
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: '0.8em'
        }
    }
});

export default withRouter(withStyles(styles, { withTheme: true })(UserCard));



// WEBPACK FOOTER //
// ./data/components/UserCard.js